<template>
  <div class="home-page">
    <!-- 全屏轮播图 -->
    <section class="hero-section">
      <el-carousel height="600px" :interval="5000" arrow="always">
        <el-carousel-item v-for="(slide, index) in carouselSlides" :key="index">
          <div class="carousel-content" :style="{ backgroundImage: `url(${slide.image})` }">
            <div class="overlay"></div>
            <div class="carousel-caption">
              <h2 class="slide-subtitle animate__animated animate__fadeInDown">{{ slide.subtitle }}</h2>
              <h1 class="slide-title animate__animated animate__fadeInUp">{{ slide.title }}</h1>
              <el-button
                class="slide-button animate__animated animate__fadeInUp"
                type="primary"
                size="large"
                @click="navigateTo(slide.buttonLink)"
              >
                {{ slide.buttonText }}
              </el-button>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>

    <!-- 主要业务领域 -->
    <section class="business-areas">
      <div class="page-container">
        <div class="business-grid">
          <div
              v-for="(area, index) in businessAreas"
              :key="index"
              class="business-card"
              @click="navigateTo(area.link)"
          >
            <div class="business-icon">
              <i :class="area.icon"></i>
            </div>
            <h3>{{ area.title }}</h3>
            <p>{{ area.desc || area.description }}</p>
            <div class="business-hover">
              <span>{{ t('home.business.learnMore', '了解更多') }} <i class="el-icon-arrow-right"></i></span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 正在发生 (新闻动态) -->
    <section class="news-section">
      <div class="page-container">
        <div class="section-header">
          <h2 class="section-title">{{ t('home.newsTitle', '正在发生') }}</h2>
        </div>

        <div class="news-content">
          <div class="main-news" v-if="newsList.length > 0">
            <div class="main-news-item" @click="viewNewsDetail(newsList[0]._id)">
              <div class="news-image">
                <img :src="newsList[0].cover ? `https://www.hexiangtaitech.com:3001${newsList[0].cover}` : require('@/assets/images/news/news-placeholder.jpg')" :alt="newsList[0].title">
              </div>
              <div class="news-info">
                <h3>{{ newsList[0].title }}</h3>
                <p>{{ getSummary(newsList[0].content, 120) }}</p>
                <div class="news-meta">
                  <span class="date">{{ formatDate(newsList[0].editTime) }}</span>
                  <span class="read-more">{{ t('home.news.readMore', '阅读更多') }} <i class="el-icon-arrow-right"></i></span>
                </div>
              </div>
            </div>
          </div>

          <div class="sub-news">
            <div
                v-for="(item, index) in newsList.slice(1, 4)"
                :key="index"
                class="sub-news-item"
                @click="viewNewsDetail(item._id)"
            >
              <div class="news-info">
                <h3>{{ item.title }}</h3>
                <div class="news-meta">
                  <span class="date">{{ formatDate(item.editTime) }}</span>
                  <span class="read-more">{{ t('home.news.readMore', '阅读更多') }} <i class="el-icon-arrow-right"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="news-more">
          <router-link to="/news" class="more-link">{{ t('home.moreNews', '探索更多') }} <i class="el-icon-arrow-right"></i></router-link>
        </div>
      </div>
    </section>
    <!-- 公司介绍视频 -->
    <section class="video-section">
      <div class="page-container">
        <div class="video-container">
          <div class="video-text">
            <h2>{{ t('home.companyVideoTitle', '威海和祥泰数码科技有限公司') }}</h2>
            <p>{{ t('home.companyVideoDesc', '威海和祥泰数码科技有限公司成立于2014年5月...') }}</p>
            <router-link to="/about" class="video-link">{{ t('home.learnMore', '了解更多') }} <i class="el-icon-arrow-right"></i></router-link>
          </div>
          <div class="video-player">
            <div class="video-placeholder" @click="playVideo">
              <img src="@/assets/images/logo/logo.jpg" alt="公司宣传视频" />
              <div class="play-button">
                <i class="el-icon-video-play"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 加入我们 -->
    <section class="join-section">
      <div class="page-container">
        <div class="join-container">
          <div class="join-content">
            <h2>{{ t('home.joinUsTitle', '加入和祥泰') }}</h2>
            <h3>{{ t('home.joinUsSub', '遇见新未来，发现新自己') }}</h3>
            <p>{{ t('home.joinUsDesc', '我们秉持能力导向、全面发展的人才理念，为有能力的员工提供广阔的发展舞台') }}</p>
            <router-link to="/recruits" class="join-link">{{ t('home.joinUsButton', '加入我们') }} <i class="el-icon-arrow-right"></i></router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- 股票信息 -->
<!--    <section class="stock-section">-->
<!--      <div class="page-container">-->
<!--        <div class="stock-container">-->
<!--          <div class="stock-item">-->
<!--            <div class="stock-name">{{ t('home.stockName', '股票名称') }}</div>-->
<!--            <div class="stock-price">20.36 <span class="up">▲ 0.42</span></div>-->
<!--            <div class="stock-time">{{ t('home.stockCutoff', '收盘时间') }}: {{ currentTime }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->

    <!-- 数据统计 -->
    <div class="statistics-section">
      <div class="page-container">
        <div class="section-header text-center">
          <h2 class="section-title">{{ t('home.statisticsTitle', '企业成就') }}</h2>
          <p class="section-desc">{{ t('home.statisticsDesc', '和祥泰数码科技有限公司致力于成为行业领导者，以下是我们的一些成就数据') }}</p>
        </div>
        <div class="statistics-container" v-loading="statisticsLoading">
          <div class="statistic-item" v-for="(item, index) in statisticsData" :key="index">
            <div class="statistic-icon">
              <i :class="item.icon"></i>
            </div>
            <div class="statistic-number">
              <CountTo
                  :start-val="0"
                  :end-val="item.value"
                  :duration="2500"
                  :decimals="item.decimals || 0"
                  separator=","
              />
              <span class="statistic-unit" v-if="item.unit">{{ item.unit }}</span>
            </div>
            <div class="statistic-title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import { getHotNews } from '@/api/news';
import { useI18n } from 'vue-i18n';
import { formatDate, getSummary } from '@/utils/helper';
import { getOverview } from '@/api/statistics';
import CountTo from '@/components/CountTo.vue';

export default {
  name: 'HomeView',
  components: { CountTo },
  setup() {
    const { t, locale } = useI18n(); // 获取当前语言
    const router = useRouter();

    const newsList = ref([]); // 新闻列表
    const isLoading = ref(false); // 是否正在加载

    const statisticsData = ref([]); // 统计数据
    const statisticsLoading = ref(false); // 统计数据加载状态

    // 获取当前时间
    const currentTime = computed(() => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    });

    // 轮播图数据
    const carouselSlides = computed(() => [
      {
        title: t('home.slides[0].title'),
        subtitle: t('home.slides[0].subtitle'),
        buttonText: t('home.slides[0].button'),
        buttonLink: '/about',
        image: require('@/assets/images/banner/banner1.jpg')
      },
      {
        title: t('home.slides[1].title'),
        subtitle: t('home.slides[1].subtitle'),
        buttonText: t('home.slides[1].button'),
        buttonLink: '/boxs',
        image: require('@/assets/images/banner/banner2.jpg')
      },
      {
        title: t('home.slides[2].title'),
        subtitle: t('home.slides[2].subtitle'),
        buttonText: t('home.slides[2].button'),
        buttonLink: '/recruits',
        image: require('@/assets/images/banner/banner3.jpg')
      }
    ]);

    // 业务领域数据国际化处理
    const businessAreas = computed(() => [
      {
        title: t('home.business[0].title'),
        description: t('home.business[0].desc'),
        icon: 'el-icon-s-opportunity',
        link: '/boxs?tab=1'
      },
      {
        title: t('home.business[1].title'),
        description: t('home.business[1].desc'),
        icon: 'el-icon-s-cooperation',
        link: '/boxs?tab=2'
      },
      {
        title: t('home.business[2].title'),
        description: t('home.business[2].desc'),
        icon: 'el-icon-s-management',
        link: '/boxs?tab=3'
      },
      {
        title: t('home.business[3].title'),
        description: t('home.business[3].desc'),
        icon: 'el-icon-s-platform',
        link: '/touch'
      }
    ]);

    // 获取新闻数据
    const fetchNews = async () => {
      isLoading.value = true;
      try {
        const res = await getHotNews({ limit: 100 });
        if (res.data && res.data.ActionType === 'ok') {
          const language = locale.value; // 获取当前语言
          const filteredNews = res.data.data.filter(news => news.languages.includes(language)); // 过滤出符合当前语言的新闻
          newsList.value = filteredNews || [];
        }
      } catch (e) {
        console.error('获取新闻失败:', e);
      } finally {
        isLoading.value = false;
      }
    };

    // 获取统计数据
    const fetchStatistics = async () => {
      statisticsLoading.value = true;
      try {
        const res = await getOverview();
        if (res.data && res.data.ActionType === 'ok') {
          const data = res.data.data;
          statisticsData.value = [
            { title: t('home.statistics.clientCount', '客户数'), value: data?.clientCount || 1000, icon: 'el-icon-user' },
            { title: t('home.statistics.projectCount', '项目数'), value: data?.projectCount || 500, icon: 'el-icon-s-grid' },
            { title: t('home.statistics.teamCount', '团队人数'), value: data?.teamCount || 120, icon: 'el-icon-s-custom' },
            { title: t('home.statistics.satisfaction', '客户满意度'), value: data?.satisfaction || 98, unit: '%', icon: 'el-icon-star-on' }
          ];
        }
      } catch (e) {
        console.error('获取统计数据失败:', e);
        statisticsData.value = [
          { title: t('home.statistics.clientCount', '客户数'), value: 1000, icon: 'el-icon-user' },
          { title: t('home.statistics.projectCount', '项目数'), value: 500, icon: 'el-icon-s-grid' },
          { title: t('home.statistics.teamCount', '团队人数'), value: 120, icon: 'el-icon-s-custom' },
          { title: t('home.statistics.satisfaction', '客户满意度'), value: 98, unit: '%', icon: 'el-icon-star-on' }
        ];
      } finally {
        statisticsLoading.value = false;
      }
    };

    // 页面加载时获取新闻数据
    onMounted(() => {
      fetchNews();
      fetchStatistics();
    });

    // 监听语言变化，重新加载新闻
    watch(() => locale.value, () => {
      fetchNews(); // 语言变化时重新加载新闻
      fetchStatistics();
    });

    // 导航到指定页面
    const navigateTo = (path) => {
      router.push(path);
    };

    // 查看新闻详情
    const viewNewsDetail = (id) => {
      router.push(`/news/${id}`);
    };

    // 播放视频
    const playVideo = () => {
      alert(t('home.video.playAlert', '播放视频功能尚未实现'));
    };

    return {
      t,
      carouselSlides,
      businessAreas,
      newsList,
      isLoading,
      currentTime,
      formatDate,
      getSummary,
      navigateTo,
      viewNewsDetail,
      playVideo,
      statisticsData,
      statisticsLoading
    };
  }
};
</script>


<style lang="scss" scoped>
.home-page {
  padding-top: 130px; /* 根据导航栏高度调整 */
  .hero-section {
    margin-top: 0;
    position: relative;

    .carousel-content {
      height: 100%;
      background-position: center;
      background-size: cover;
      position: relative;

      .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.1);
      }

      .carousel-caption {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        color: white;
        width: 80%;
        max-width: 800px;
        z-index: 2;

        .slide-subtitle {
          font-size: 28px;
          font-weight: 500;
          margin-bottom: 15px;
          letter-spacing: 1px;
          text-shadow: 0 0 4px rgba(0, 0, 0, 0.6);
          color: #fff; /* 设置为白色 */}

        .slide-title {
          font-size: 48px;
          font-weight: 700;
          margin-bottom: 30px;
          line-height: 1.2;
          color: #fff;
          text-shadow: 0 0 4px rgba(0, 0, 0, 0.6);
        }

        .slide-button {
          padding: 12px 30px;
          font-size: 16px;
          font-weight: 500;
          background-color: #163C7D;
          border-color: #163C7D;

          &:hover {
            background-color: darken(#163C7D, 10%);
            border-color: darken(#163C7D, 10%);
          }
        }
      }
    }
  }

  .business-areas {
    padding: 80px 0;
    background-color: #f9f9f9;

    .business-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 30px;

      @media (max-width: 1200px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
      }

      .business-card {
        background-color: white;
        padding: 40px 30px;
        border-radius: 8px;
        text-align: center;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
        cursor: pointer;

        &:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);

          .business-hover {
            bottom: 0;
          }
        }

        .business-icon {
          margin-bottom: 20px;

          i {
            font-size: 48px;
            color: #163C7D;
          }
        }

        h3 {
          font-size: 22px;
          font-weight: 600;
          color: #333;
          margin-bottom: 15px;
        }

        p {
          font-size: 15px;
          color: #666;
          line-height: 1.6;
          margin-bottom: 20px;
        }

        .business-hover {
          position: absolute;
          bottom: -50px;
          left: 0;
          width: 100%;
          background-color: #163C7D;
          color: white;
          padding: 12px 0;
          transition: all 0.3s ease;
          font-weight: 500;

          span {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 5px;
          }
        }
      }
    }
  }

  .news-section {
    padding: 80px 0;

    .section-header {
      text-align: center;
      margin-bottom: 50px;

      .section-title {
        font-size: 32px;
        font-weight: 700;
        color: #163C7D;
        position: relative;
        display: inline-block;

        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: -15px;
          width: 60px;
          height: 3px;
          background-color: #163C7D;
          transform: translateX(-50%);
        }
      }
    }

    .news-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 30px;
      margin-bottom: 40px;

      @media (max-width: 992px) {
        grid-template-columns: 1fr;
      }

      .main-news {
        .main-news-item {
          background-color: white;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
          }

          .news-image {
            height: 300px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: transform 0.5s ease;

              &:hover {
                transform: scale(1.05);
              }
            }
          }

          .news-info {
            padding: 30px;

            h3 {
              font-size: 22px;
              font-weight: 600;
              color: #333;
              margin-bottom: 15px;
              line-height: 1.4;
            }

            p {
              font-size: 15px;
              color: #666;
              margin-bottom: 20px;
              line-height: 1.6;
            }

            .news-meta {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .date {
                color: #999;
                font-size: 14px;
              }

              .read-more {
                color: #163C7D;
                font-weight: 500;
                display: flex;
                align-items: center;
                gap: 5px;
              }
            }
          }
        }
      }

      .sub-news {
        display: flex;
        flex-direction: column;
        gap: 20px;

        .sub-news-item {
          background-color: white;
          border-radius: 8px;
          padding: 25px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            transform: translateX(5px);
            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
          }

          .news-info {
            h3 {
              font-size: 18px;
              font-weight: 600;
              color: #333;
              margin-bottom: 15px;
              line-height: 1.4;

              // 两行文本溢出省略
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .news-meta {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .date {
                color: #999;
                font-size: 14px;
              }

              .read-more {
                color: #163C7D;
                font-weight: 500;
                display: flex;
                align-items: center;
                gap: 5px;
              }
            }
          }
        }
      }
    }

    .news-more {
      text-align: center;

      .more-link {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        color: #163C7D;
        font-size: 16px;
        font-weight: 500;
        text-decoration: none;
        padding: 10px 20px;
        border: 1px solid #163C7D;
        border-radius: 4px;
        transition: all 0.3s ease;

        &:hover {
          background-color: #163C7D;
          color: white;
        }
      }
    }
  }

  .video-section {
    padding: 80px 0;
    background-color: #f5f5f5;

    .video-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 50px;
      align-items: center;

      @media (max-width: 992px) {
        grid-template-columns: 1fr;
      }

      .video-text {
        h2 {
          font-size: 36px;
          font-weight: 700;
          color: #163C7D;
          margin-bottom: 20px;
          line-height: 1.3;
        }

        p {
          font-size: 16px;
          color: #666;
          margin-bottom: 30px;
          line-height: 1.7;
        }

        .video-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: #163C7D;
          font-size: 16px;
          font-weight: 500;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      .video-player {
        .video-placeholder {
          position: relative;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          cursor: pointer;

          img {
            width: 100%;
            height: 350px;
            object-fit: cover;
          }

          .play-button {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 80px;
            height: 80px;
            background-color: rgba(22, 60, 125, 0.8);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;

            i {
              font-size: 40px;
              color: white;
            }

            &:hover {
              background-color: rgba(22, 60, 125, 1);
              transform: translate(-50%, -50%) scale(1.1);
            }
          }
        }
      }
    }
  }

  .join-section {
    padding: 100px 0;
    background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('~@/assets/images/about/滚轮图鸟瞰图.jpg');
    background-size: cover;
    background-position: center;
    background-attachment: fixed;

    .join-container {
      display: flex;
      justify-content: center;
      align-items: center;

      .join-content {
        text-align: center;
        color: white;
        max-width: 700px;
        text-shadow: 0 0 4px rgba(0, 0, 0, 0.6);

        h2 {
          font-size: 42px;
          font-weight: 700;
          margin-bottom: 15px;
          color: #fff;
          text-shadow: 0 0 4px rgba(0, 0, 0, 0.6);
        }

        h3 {
          font-size: 28px;
          font-weight: 500;
          margin-bottom: 20px;
          color: #fff;
          text-shadow: 0 0 4px rgba(0, 0, 0, 0.6);
        }

        p {
          font-size: 16px;
          margin-bottom: 30px;
          line-height: 1.7;
          opacity: 0.9;
        }

        .join-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background-color: #163C7D;
          color: white;
          padding: 12px 30px;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 500;
          text-decoration: none;
          transition: all 0.3s ease;

          &:hover {
            background-color: lighten(#163C7D, 10%);
            transform: translateY(-3px);
          }
        }
      }
    }
  }

  .stock-section {
    padding: 40px 0;

    .stock-container {
      display: flex;
      justify-content: center;

      .stock-item {
        background-color: #f9f9f9;
        padding: 20px 40px;
        border-radius: 8px;
        text-align: center;

        .stock-name {
          font-size: 18px;
          font-weight: 600;
          color: #163C7D;
          margin-bottom: 10px;
        }

        .stock-price {
          font-size: 24px;
          font-weight: 700;
          color: #333;
          margin-bottom: 5px;

          .up {
            color: #ff4d4f;
            font-size: 16px;
          }
        }

        .stock-time {
          font-size: 14px;
          color: #999;
        }
      }
    }
  }

  .statistics-section {
    background-color: #f5f7fa;
    padding: 80px 0;

    .statistics-container {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 30px;
      margin-top: 50px;

      @media (max-width: 992px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 576px) {
        grid-template-columns: 1fr;
      }

      .statistic-item {
        background-color: #fff;
        border-radius: 8px;
        padding: 30px;
        text-align: center;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        transition: transform 0.3s, box-shadow 0.3s;

        &:hover {
          transform: translateY(-10px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        }

        .statistic-icon {
          font-size: 40px;
          color: #409EFF;
          margin-bottom: 20px;
        }

        .statistic-number {
          font-size: 36px;
          font-weight: 700;
          color: #303133;
          margin-bottom: 10px;

          .statistic-unit {
            font-size: 20px;
            margin-left: 5px;
          }
        }

        .statistic-title {
          font-size: 16px;
          color: #606266;
        }
      }
    }
  }
}
</style>
